var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center bg-1 p-2 mt-1 mb-1"},[_c('p',{staticClass:"mb-1"},[_vm._v("Kindly ensure that image are in proper dimension. Height in-between "),_c('b',[_vm._v(_vm._s(_vm.height1)+"px-"+_vm._s(_vm.height2)+"px")]),_vm._v(" and Width in-between "),_c('b',[_vm._v(_vm._s(_vm.width1)+"px-"+_vm._s(_vm.width2)+"px")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }